import { FlatTreeControl } from "@angular/cdk/tree";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild
} from "@angular/core";
import {
  MatTreeFlattener,
  MatTreeFlatDataSource,
  MatDialog,
  MatSelectChange,
  MatPaginator
} from "@angular/material";

import { IRole } from "src/app/interfaces/role";
import { RoleEntryComponent } from "../role-entry/role-entry.component";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";

interface ExampleFlatNode {
  expandable: boolean;
  Title: string;
  Id: number;
  ParentId: number;
  level: number;
}

@Component({
  selector: "app-role-tree-structure",
  templateUrl: "./role-tree-structure.component.html",
  styleUrls: ["./role-tree-structure.component.css"]
})
export class RoleTreeStructureComponent implements OnInit {
  gList: any;
  @Output() roleId = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  private transformer = (node: IRole, level: number) => {
    return {
      expandable: !!node.Children && node.Children.length > 0,
      Title: node.Title,
      Id: node.Id,
      ParentId: node.ParentId,
      level: level
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.Children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  isOwner: boolean;
  companyList: ICompany;
  companySelected: string;
  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    private roleService: RoleService,
    private holdingService: HoldingService,
    private companyService: CompanyService
  ) {}

  ngOnInit() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.roleService.change.subscribe(() => {
      this.refresh();
    });
    this.refresh();
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  refresh() {
    this.roleService.list().subscribe(res => {
      this.dataSource.data = res.DataList;
      this.companySelected = this.cidService.getCID();
    });
  }

  add(node: IRole): void {
    this.dialog
      .open(RoleEntryComponent, {
        width: "350px",
        data: node && node.Id ? node.Id : null
      })
      .afterClosed()
      .subscribe(() => {
        this.roleService.list().subscribe(re => {
          this.paginator.pageIndex = 0;
          this.dataSource = re.DataList;
          this.paginator.length = re.Total;
        });
      });
  }

  onDetail(nodeId: any) {
    this.roleId.emit(nodeId);
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }
  rolesList(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    this.roleService.list().subscribe(res => {
      this.dataSource.data = res.DataList;
      this.roleService.hide();
    });
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
